import { CarConfigStep } from "../../../../common-deprecated/features/apheleia/utils/carConfigNavigationUtils";
import { trackEvent } from "../../../../common-deprecated/utils/tracking";
import { useCarConfigSelector } from "../redux/store";
import type { StepsType } from "../utils/tracking";
import { CAR_CONFIG_STEP, COMPONENT_NAME, COMPONENT_GROUP, STEP_MAPPING } from "../utils/tracking";
import { CarConfigConfigureSection } from "../utils/types/SectionTypes";

// General Tracking
export const useAphStepTracking = (): ((step: StepsType) => void) => {
    const useLbxJourney = useCarConfigSelector((store) => store.commonSettings.query.useLbxJourney);

    return (step: StepsType): void => {
        let workflowName = "carconfigurator";
        if (step === CarConfigStep.Highlights || step === CarConfigStep.Specs) {
            workflowName = "grade-details";
        }

        let conversion = 0;
        if (step === CarConfigConfigureSection.Summary) {
            conversion = 1;
        }
        trackEvent(
            {
                name: step === CarConfigConfigureSection.Summary ? "configdetailsevent" : CAR_CONFIG_STEP,
                component: COMPONENT_NAME,
                group: COMPONENT_GROUP,
                action: "workflow",
                label: STEP_MAPPING[step],
            },
            {
                workflow: {
                    name: workflowName,
                    step: step === CarConfigConfigureSection.Services ? STEP_MAPPING[step] : step,
                    conversion,
                    variant: useLbxJourney ? "apheleia-custom-journey" : "apheleia",
                },
            },
            { carconfigStep: STEP_MAPPING[step] },
        );
    };
};
